export default "__VITE_ASSET__2CLkaFqP__"